import { createReducer } from '@reduxjs/toolkit';

import type { RootState } from '..';
import { NotificationItem } from '../types';
import {
	markReadSuccess,
	markSeenSuccess,
	notificationsClear,
	notificationsFailure,
	notificationsRequest,
	notificationsSuccess,
} from './notificationsActions';

export type NotificationsState = {
	loading: boolean;
	error?: string;
	items: NotificationItem[];
};

const initialState: NotificationsState = {
	loading: false,
	items: [],
};

export const notificationsReducer = createReducer(initialState, b => {
	b.addCase(notificationsRequest, s => {
		s.loading = true;
		s.error = undefined;
	});
	b.addCase(notificationsSuccess, (s, a) => {
		s.loading = false;
		s.items = a.payload.items;
	});
	b.addCase(notificationsFailure, (s, a) => {
		s.loading = false;
		s.error = a.payload;
	});
	b.addCase(markReadSuccess, (s, a) => {
		const id = a.payload.notificationId;
		s.items = s.items.filter(x => x.id !== id);
	});
	b.addCase(markSeenSuccess, (s, a) => {
		const id = a.payload.notificationId;
		const item = s.items.find(x => x.id === id);
		if (item) item.read = true;
	});
	b.addCase(notificationsClear, s => {
		s.items = [];
		s.error = undefined;
		s.loading = false;
	});
});

export const selectNotifications = (s: RootState) => s.notifications.items;
export const selectNotificationsLoading = (s: RootState) => s.notifications.loading;
export const selectNotificationsError = (s: RootState) => s.notifications.error;
export const selectUnreadCount = (s: RootState) =>
	s.notifications.items.reduce((acc, n) => acc + (n.read ? 0 : 1), 0);
